export var NewsletterStatus;
(function (NewsletterStatus) {
    NewsletterStatus["CONFIRMED"] = "confirmed";
    NewsletterStatus["REPEATED_CONFIRMATION"] = "repeated-confirmation";
    NewsletterStatus["EXPIRED"] = "expired";
    NewsletterStatus["FAILED"] = "failed";
})(NewsletterStatus || (NewsletterStatus = {}));
export var NewsletterQueryParams;
(function (NewsletterQueryParams) {
    NewsletterQueryParams["STATUS"] = "status";
    NewsletterQueryParams["LANGUAGE"] = "language";
    NewsletterQueryParams["INDIVIDUAL_ID"] = "individualId";
})(NewsletterQueryParams || (NewsletterQueryParams = {}));
export const LANGUAGE_SEPARATOR = '{language}';
export const INDIVIDUAL_ID_SEPARATOR = '{individualId}';
